import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SPUpdateModalUI from './SPUpdateModalUI.js'

class SPUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      parameterValue: '',
      parameterValueError: null,
      helpText: ''
    }
  }

  render() {
    return (
      <SPUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        parameterName={this.props.parameterName}
        financialYear={this.props.financialYear}
        parameterValue={this.state.parameterValue}
        helpText={this.state.helpText}
        onParameterValueChange={(event) => { this.setState({ parameterValue: event.target.value }) }}
        parameterValueError={this.state.parameterValueError}
        setParameterValueError={(error) => { this.setState({ parameterValueError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentWillReceiveProps(props) {
    let helpText
    switch(props.parameterName) {
      case 'companyCreditRating':
        helpText = 'Enter CIBIL rank CMR-1 to CMR-10'
        break
      case 'ldPaid':
        helpText = 'Enter Yes of No'
    }

    this.setState({
      parameterValue : props.parameterValue,
      helpText: helpText,
      submitted: false,
      errorList: null
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/scoreParameters/${this.props.parameterName}`,
      this.onSubmitCallback, {
        financialYear: this.props.financialYear,
        parameterValue: this.state.parameterValue,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      this.props.onUpdate(this.state.parameterValue)
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 500)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default withRouter(SPUpdateModalSF)
